var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPersonYellow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "person_yellow_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#person_yellow_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F0FF14",
  d: "M8.001 8.001a2.568 2.568 0 0 1-1.883-.783 2.568 2.568 0 0 1-.783-1.883c0-.734.26-1.361.783-1.884a2.568 2.568 0 0 1 1.883-.783c.734 0 1.361.261 1.884.783.522.523.783 1.15.783 1.884 0 .733-.261 1.36-.783 1.883A2.568 2.568 0 0 1 8 8.001Zm4 5.334h-8c-.366 0-.68-.13-.941-.392a1.284 1.284 0 0 1-.392-.942v-.533c0-.378.097-.725.292-1.042.194-.316.452-.558.775-.725a9.897 9.897 0 0 1 2.1-.775 9.172 9.172 0 0 1 4.333 0c.711.173 1.411.43 2.1.775.322.167.58.409.775.725.194.317.292.664.292 1.042v.533c0 .367-.13.68-.392.942a1.284 1.284 0 0 1-.942.392Zm-8-1.334h8v-.533a.649.649 0 0 0-.333-.567 8.69 8.69 0 0 0-1.817-.675 7.734 7.734 0 0 0-3.7 0 8.69 8.69 0 0 0-1.816.675.649.649 0 0 0-.334.567v.533Zm4-5.333c.367 0 .68-.13.942-.392.261-.26.392-.575.392-.941 0-.367-.13-.68-.392-.942a1.284 1.284 0 0 0-.942-.392c-.366 0-.68.13-.941.392a1.284 1.284 0 0 0-.392.942c0 .366.13.68.392.941.26.261.575.392.941.392Z"
}))));
export default SvgPersonYellow;